import { render } from "./Hose.vue?vue&type=template&id=6bb1f91d"
import script from "./Hose.vue?vue&type=script&lang=js"
export * from "./Hose.vue?vue&type=script&lang=js"
script.render = render

export default script